import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LegalModalType, LegalModalsService } from '../services/legal-modals.service';

@Component({
  selector: 'loyaltic-legal-modals',
  templateUrl: './legal-modals.component.html',
  styleUrls: ['./legal-modals.component.scss']
})
export class LegalModalsComponent {
  activeModal$: Observable<LegalModalType>;

  constructor(private readonly legalModalsService: LegalModalsService) {
    this.activeModal$ = this.legalModalsService.activeModal$;
  }

  closeModal(): void {
    this.legalModalsService.close();
  }
}
